module.exports = __webpack_public_path__ + "img/straightcurve_logo_white.231ec616.png";